import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-textme',
  template: `
    <p>
      textme worksmmmmmmmmmmmmmmmmm!
    </p>
  `,
  styles: [
  ],
})
export class TextmeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
